var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "handle-coupon" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "handle-coupon-body",
          attrs: {
            "element-loading-text": "获取信息中...",
            "element-loading-spinner": "el-icon-loading",
          },
        },
        [
          _c("h3", [_vm._v("基本信息")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "my-table" }, [
            _c("div", { staticClass: "my-table-item" }, [
              _c("label", { staticClass: "item-label" }, [_vm._v("促销ID")]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value" }, [
                _vm._v(_vm._s(_vm.form.id || "--")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "my-table-item" }, [
              _c("label", { staticClass: "item-label" }, [_vm._v("促销名称")]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value" }, [
                _vm._v(_vm._s(_vm.form.name || "--")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "my-table-item" }, [
              _c("label", { staticClass: "item-label" }, [_vm._v("促销时间")]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value" }, [
                _c("div", [_vm._v(_vm._s(_vm.form.startTime || "--"))]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.form.endTime))]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "my-table-item" }, [
              _c("label", { staticClass: "item-label" }, [_vm._v("优惠信息")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item-value" },
                [
                  _vm.form.promotionDetailStr
                    ? _vm._l(
                        _vm.form.promotionDetailStr.split("\n"),
                        function (info, index) {
                          return _c("div", { key: index }, [
                            _vm._v(_vm._s(info)),
                          ])
                        }
                      )
                    : _c("span", [_vm._v("--")]),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "my-table-item" }, [
              _c("label", { staticClass: "item-label" }, [_vm._v("参与商品")]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.form.applicableRangeTypeDesc || "--") +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "my-table-item" }, [
              _c("label", { staticClass: "item-label" }, [
                _vm._v("适用分销客户"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value" }, [
                _vm._v(_vm._s(_vm.form.distributionCustomersName || "--")),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c("h3", [_vm._v("促销适用范围")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "mb20 range-type" }, [
            _vm._v(_vm._s(_vm.form.applicableRangeTypeDesc || "--")),
          ]),
          _vm._v(" "),
          [2, 3].includes(_vm.form.applicableRangeType)
            ? _c(
                "div",
                { staticClass: "show-goods" },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "mb20",
                      attrs: { data: _vm.showTableData.list },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "ID",
                          prop: "id",
                          align: "center",
                          width: "100",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "SKU编码",
                          prop: "skuCode",
                          align: "center",
                          width: "150",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "名称",
                          prop: "skuName",
                          align: "center",
                          "min-width": "100",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "零售价",
                          prop: "otPrice",
                          align: "center",
                          width: "100",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "品牌",
                          prop: "brandName",
                          align: "center",
                          width: "100",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "供应商",
                          prop: "supplierName",
                          align: "center",
                          width: "200",
                          "show-overflow-tooltip": "",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-pagination", {
                    staticStyle: {
                      "text-align": "right",
                      "margin-top": "10px",
                    },
                    attrs: {
                      "page-sizes": [20, 40, 60, 80],
                      "page-size": _vm.pageData.limit,
                      "current-page": _vm.pageData.page,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.showTableData.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              )
            : _vm.form.applicableRangeType == 4
            ? _c("el-cascader", {
                staticStyle: { width: "100%" },
                attrs: {
                  disabled: true,
                  placeholder: "指定分类",
                  options: _vm.showCateIdOption,
                  props: {
                    children: "child",
                    label: "name",
                    value: "id",
                    multiple: true,
                  },
                },
                model: {
                  value: _vm.form.cateIdList,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "cateIdList", $$v)
                  },
                  expression: "form.cateIdList",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("CopyLinkVue", { ref: "CopyLinkVueRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }